export function clampValue(value: number, min: number, max: number, step: number) {
  const finite = Number.isFinite(value) ? value : min;
  const increment = step > 0 ? step : (max - min) / 100 || 1;
  return Number(Math.min(max, Math.max(min, min + Math.round((finite - min) / increment) * increment)).toFixed(10));
}

export function gestureSpeed(event: { shiftKey?: boolean; altKey?: boolean }) {
  return (event.shiftKey ? 5 : 1) * (event.altKey ? .2 : 1);
}

export function keyboardValue(key: string, value: number, min: number, max: number, step: number, speed = 1) {
  if (key === 'Home') return min;
  if (key === 'End') return max;
  if (key === 'ArrowRight' || key === 'ArrowUp') return value + step * speed;
  if (key === 'ArrowLeft' || key === 'ArrowDown') return value - step * speed;
  if (key === 'PageUp') return value + step * 10 * speed;
  if (key === 'PageDown') return value - step * 10 * speed;
  return undefined;
}
